import { getRequest } from '../api-handler';
import { SegmentDetailDto } from './segment';

export const SegmentApi = {
  getById: (id: number) => getRequest<SegmentDetailDto>(`/segments/${id}`)
};
